import React from "react";
import { useTranslation } from "react-i18next";
import SectionComponent from "../../../../components/utils/SectionComponent";
import "./CDRsList.scss";

function CDRsList() {
  const { t } = useTranslation()
  return (
    <div className="container-CDRs-list">
      <div className="texts-CDRs-list">

        <SectionComponent title={t("telecom.cdr_list.cdr.title")} text={t("telecom.cdr_list.cdr.section_text_1")}>
          <p>{t("telecom.cdr_list.cdr.section_text_2")}</p>
        </SectionComponent>


        <SectionComponent title={t("telecom.cdr_list.routing.title")} text={t("telecom.cdr_list.routing.section_text_1")}>
          <p>{t("telecom.cdr_list.routing.section_text_2")}</p>
        </SectionComponent>

        <SectionComponent title={t("telecom.cdr_list.business_rules.title")} text={t("telecom.cdr_list.business_rules.section_text_1")}>
          <p>{t("telecom.cdr_list.business_rules.section_text_2")}</p>
        </SectionComponent>


        <SectionComponent title={t("telecom.cdr_list.subscriptions.title")} text={t("telecom.cdr_list.subscriptions.section_text_1")}>
          <p>{t("telecom.cdr_list.subscriptions.section_text_2")}</p>
          <p>{t("telecom.cdr_list.subscriptions.section_text_3")}</p>
        </SectionComponent>

        <SectionComponent title={t("telecom.cdr_list.precision_errors.title")} text={t("telecom.cdr_list.precision_errors.section_text_1")}>
          <p>{t("telecom.cdr_list.precision_errors.section_text_2")}</p>
        </SectionComponent>


      </div>
    </div>
  );
}

export default CDRsList;
